export class IndicatorDataset {
    sourceType: 'service' | 'report' = 'service';
    reportId: any;
    service: string;
    fileFormat: string;
    match: string;
    compare: string[];
    date: string;
    name: string;
}

export class Indicator {
    id: number;
    name: string;
    year: string;
    operation: string;
    sector: string = 'Default';
    datasets: IndicatorDataset[] = [new IndicatorDataset(), new IndicatorDataset()];
    filterDateFrom: Date;
    filterDateTo: Date;
    percentageMin: number;
    percentageMax: number;
    riskManagement: boolean;
    lastRun: Date;
    Default = { ponderation: 0, r1: [1, 33], r2: [34, 66], r3: [67, 100] }
    IFU1 = { ponderation: 0, r1: [1, 33], r2: [34, 66], r3: [67, 100] }
    IFU2 = { ponderation: 0, r1: [1, 33], r2: [34, 66], r3: [67, 100] }
    IFU3 = { ponderation: 0, r1: [1, 33], r2: [34, 66], r3: [67, 100] }
    IFU4 = { ponderation: 0, r1: [1, 33], r2: [34, 66], r3: [67, 100] }
    IFU5 = { ponderation: 0, r1: [1, 33], r2: [34, 66], r3: [67, 100] }
}